module.exports = __webpack_public_path__ + "img/14.f36f9338.jpg";